import { POINTS_SET, POINTS_TRIGGER_BOUNCE, POINTS_CLEAR_BOUNCE } from '../types/pointsTypes.js';

const initialState = {
  value: 0,
  prevValue: 0,
  bounce: false,
};

export default function pointsReducer(state = initialState, action) {
  switch (action.type) {
    case POINTS_SET:
      return { ...state, prevValue: state.value, value: action.payload };
    case POINTS_TRIGGER_BOUNCE:
      return { ...state, bounce: true };
    case POINTS_CLEAR_BOUNCE:
      return { ...state, bounce: false };
    default:
      return state;
  }
}